import BackendProxy from './backendproxy';
import StringUtils from '../utils/strings';

// Module that provides master data records in the format required by UI components
const MasterDataProvider = (function () {
  // Map of provices of each country (cache of loaded provinces)
  const mapCountryProvinces = {};

  return {
    // Returns an array with all countries supported, in format: [{name: "Country name", isoCode: "Country ISO code"}]
    //todo delete this and check it is not used
    getCountriesArray() {
      return [];
    },

    // Returns an array with all provinces of the specified country, in format: [{id: 1, code: "AK", name: "Alaska"}]
    getCountryProvincesArray(countryIsoCode, okCallback) {
      const curCountryIsoCode = StringUtils.trimToEmpty(countryIsoCode);

      // Check whether the provinces of the specified country have been cached
      if (mapCountryProvinces[curCountryIsoCode]) {
        okCallback(mapCountryProvinces[curCountryIsoCode]);
      } else {
        BackendProxy.getCountryProvinces(
          countryIsoCode,
          arrProvinces => {
            mapCountryProvinces[curCountryIsoCode] = arrProvinces;
            okCallback(arrProvinces);
          },
          (errCode, errMsg, details) => {
            console.log(
              `Failed to get provinces of: ${countryIsoCode} from backend. ${errCode} - ${errMsg} - ${details}`
            );
            okCallback([]);
          }
        );
      }
    },
  };
})();

export default MasterDataProvider;
